




























import {Component, Watch, Mixins} from 'vue-property-decorator'
import {$, MixinUpload} from 'simpli-web-sdk'
import {UploadConfig} from '@/config/upload.config'
import * as Helper from '@/helpers'
import {FileObject} from 'image-compressor.js'
import {AppConfig} from '@/config/app.config'
import Carga from '@/model/resource/Carga'
import AssociarCargaMotoristaRequest from '@/model/request/AssociarCargaMotoristaRequest'

@Component
export default class ItDriverAssociationCsvUpload extends Mixins(MixinUpload) {
  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  @Watch('files')
  async filesEvent(files: FileObject[]) {
    if (!files.length) return
    $.await.init('uploadCsv')

    const blueprint = AppConfig.csvBlueprint.queryDriverAssociation
    const data = await Helper.csvToNormalizedData(files[0].file, blueprint)

    const request = new AssociarCargaMotoristaRequest()
    request.cargas = data.map((item) => {
      const model = new Carga()
      model.idCargaPk = Number(item.idCarga) || 0
      model.idMotoristaFk = Number(item.idMotorista) || 0
      return model
    })

    try {
      await request.associarCargaMotorista()
    } finally {
      $.await.done('uploadCsv')
    }

    Helper.success('system.success.associate')

    this.$emit('associate')

    this.files = []
  }
}
